export const hyphenateString = (input: string) =>
  input
    .toLowerCase()
    .replace(/\_/g, " ")
    .replace(/(?<!^)([A-Z])/g, (match) => " " + match.toLowerCase())
    .replace(/\s+/g, "-")
    .replace(/\W+/g, "-");

export const getDataAutomationId = (id: string | undefined = "") => ({
  "data-automation-id": hyphenateString(id) || undefined,
});
